<template>
  <Teleport to="body">
    <!--
      하단 CTA 바가 있으면 그 위로 비킨다.
      --app-bottom-inset은 StickyBottomBar가 자기 높이(safe-area 포함)로 채우고,
      바가 없는 화면에서는 정의되지 않아 safe-area만 적용된다.

      바깥 요소가 위치·중앙정렬을, 안쪽 요소가 등장 애니메이션을 맡는다.
      한 요소에서 둘 다 transform으로 처리하면 중앙정렬(-50%)과 애니메이션이 충돌한다.
    -->
    <div
      class="pointer-events-none fixed left-1/2 z-[60] w-[calc(100%-2rem)] max-w-[448px] -translate-x-1/2"
      :style="{ bottom: 'calc(var(--app-bottom-inset, env(safe-area-inset-bottom)) + 0.75rem)' }"
    >
      <Transition name="snack">
        <div
          v-if="snackbar.isOpen"
          class="pointer-events-auto whitespace-pre-line rounded-[var(--radius-md)] px-4 py-3 text-[14px] leading-snug shadow-lg"
          :class="toneClass"
          role="status"
          aria-live="polite"
          @click="close"
        >
          {{ snackbar.text }}
        </div>
      </Transition>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSnackbar } from '@/shared/composables/useSnackbar'

const { snackbar, close } = useSnackbar()

const toneClass = computed(() => {
  switch (snackbar.value.tone) {
    case 'error':
      return 'bg-danger text-white'
    case 'success':
      return 'bg-success text-white'
    default:
      return 'bg-secondary text-on-secondary'
  }
})
</script>

<style scoped>
/*
 * 투명도만 전환한다.
 * 이동(transform)을 함께 쓰면, 사라지는 중에 새 메시지가 뜰 때
 * enter-from과 leave-active가 겹쳐 이동값이 고착되고 토스트가 아래로 밀린 채 남는다.
 * (실제로 하단 CTA 바에 8px 겹쳐 보이던 원인)
 */
.snack-enter-active,
.snack-leave-active {
  transition: opacity 0.2s ease;
}
.snack-enter-from,
.snack-leave-to {
  opacity: 0;
}
</style>
